import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { VpHookFormColorInput, VpHookFormInput } from '../..';
import { useFetchPluginById } from '../../../hooks';

export const VpPluginBoxShadowInputs = ({ disabled }) => {
  const { data } = useFetchPluginById();
  const boxShadowData = data?.styles?.boxShadow || '0px 0px 0px 0px rgb(0 0 0 / 0.25)';
  const [values, color] = boxShadowData.split(' rgb');
  const [x, y, blur, spread] = values.split(' ');

  return (
    <Stack alignItems="end" spacing={1}>
      <Stack direction="row" alignItems="end" spacing={1}>
        <VpHookFormInput
          disableHelperText
          isNumber
          maxLength={3}
          required
          defaultValue={x}
          name="shadowX"
          startAdornment="X"
          disabled={disabled}
          fallbackDefaultValue="0"
          includeDisplayInput
        />
        <VpHookFormInput
          isNumber
          maxLength={3}
          required
          name="shadowY"
          startAdornment="Y"
          defaultValue={y}
          disableHelperText
          disabled={disabled}
          fallbackDefaultValue="4"
          includeDisplayInput
        />
        <VpHookFormInput
          isNumber
          maxLength={3}
          required
          name="shadowBlur"
          defaultValue={blur}
          startAdornment="Blur"
          disableHelperText
          disabled={disabled}
          fallbackDefaultValue="8"
          includeDisplayInput
        />
        <VpHookFormInput
          isNumber
          maxLength={3}
          required
          name="shadowSpread"
          startAdornment="Spread"
          defaultValue={spread}
          disableHelperText
          disabled={disabled}
          fallbackDefaultValue="0"
          includeDisplayInput
        />
      </Stack>
      <VpHookFormColorInput
        isRgba
        required
        name="shadowColor"
        disableHelperText
        defaultValue={color}
        disabled={disabled}
      />
    </Stack>
  );
};

VpPluginBoxShadowInputs.propTypes = {
  disabled: PropTypes.bool
};

export default VpPluginBoxShadowInputs;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginBoxShadowInputs.jsx